import { useEffect, useState } from "react";
import { getLandingPageSettings } from "../../api/getLandingPageSettings";
import "./Features.css";

const Features = () => {
  const [heading, setHeading] = useState({
    title: "",
    subtitle: "",
  });

  const [features, setFeatures] = useState([]);

  useEffect(() => {
    const fetchSettings = async () => {
      const data = await getLandingPageSettings();
      if (!data) return;

      setHeading({
        title:
          data?.features_title?.value ||
          data?.features_title ||
          "",
        subtitle:
          data?.features_subtitle?.value ||
          data?.features_subtitle ||
          "",
      });

      const featureList = [];

      for (let i = 1; i <= 9; i++) {
        const title =
          data?.[`feature_${i}_title`]?.value ||
          data?.[`feature_${i}_title`];

        const desc =
          data?.[`feature_${i}_desc`]?.value ||
          data?.[`feature_${i}_desc`];

        if (title && desc) {
          featureList.push({
            title,
            desc,
          });
        }
      }

      setFeatures(featureList);
    };

    fetchSettings();
  }, []);

  return (
    <section className="py-5 bg-light" id="features">
      <div className="container mt-5">
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-3">{heading.title}</h2>
          {heading.subtitle && (
            <p className="text-muted mx-auto" style={{ maxWidth: "720px" }}>
              {heading.subtitle}
            </p>
          )}
        </div>

        <div className="row g-4 justify-content-center">
          {features.map((item, index) => (
            <div key={index} className="col-md-6 col-lg-4">
              <div className="h-100 p-4 bg-white rounded shadow-sm">
                <h5 className="fw-semibold mb-2">{item.title}</h5>
                <p className="text-muted mb-0">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
